var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBySystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12619_42222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 19.2031C4.92838 19.2031 0.800781 15.0755 0.800781 10.0031C0.800781 4.93072 4.92838 0.803125 10.0008 0.803125C15.0732 0.803125 19.2008 4.93072 19.2008 10.0031C19.2008 15.0755 15.0732 19.2031 10.0008 19.2031ZM13.4848 7.08712C13.6408 6.93112 13.6408 6.67513 13.4848 6.51913C13.4048 6.44313 13.3048 6.40312 13.2008 6.40312C13.0968 6.40312 12.9968 6.44313 12.9168 6.51913L10.0008 9.43512L7.08478 6.51913C7.00478 6.44313 6.90478 6.40312 6.80078 6.40312C6.69678 6.40312 6.59678 6.44313 6.51678 6.51913C6.36078 6.67513 6.36078 6.93112 6.51678 7.08712L9.43278 10.0031L6.51678 12.9191C6.36078 13.0751 6.36078 13.3311 6.51678 13.4871C6.67278 13.6431 6.92878 13.6431 7.08478 13.4871L10.0008 10.5711L12.9168 13.4871C13.0728 13.6431 13.3288 13.6431 13.4848 13.4871C13.6408 13.3311 13.6408 13.0751 13.4848 12.9191L10.5688 10.0031L13.4848 7.08712Z",
    fill: "#336FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12619_42222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBySystem);
export default __webpack_public_path__ + "static/media/cancelBySystem.8e48227fc56fdb28efe799cad4c2a5d2.svg";
export { ForwardRef as ReactComponent };